import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import type { Course as CourseType, Opportunities, SemesterItem } from '../../types';
import styles from './course.module.css';

export type CourseProps = {
    course: CourseType | Opportunities;
    onOpenItem: (item: SemesterItem) => void;
};

export const Course = ({ course, onOpenItem }: CourseProps) => {
    const { t } = useTranslation();
    const isClickable =
        course.type === 'opportunities' ||
        (course.type === 'course' && (Boolean(course.courseCode) || Boolean(course.description)));
    const href = course.type === 'course' ? course.href : undefined;
    const Component = href ? 'a' : isClickable ? 'button' : 'div';

    const handleClick = isClickable
        ? (e: React.MouseEvent) => {
              e.preventDefault();
              onOpenItem(course);
          }
        : undefined;

    const label = course.type === 'course' ? course.label : undefined;
    const variant = course.type === 'course' ? course.variant : 'Elective';
    const credits = course.credits || -1;

    return (
        <li className={styles.courseItem} data-rows={course.rows}>
            <Component href={href} className={styles.course} data-variant={variant} onClick={handleClick}>
                <span className={styles.courseContent}>
                    {label && <span className={styles.label}>{label}</span>}
                    <span className={styles.title}>{course.title}</span>
                </span>
                {credits >= 0 && (
                    <span className={classNames(styles.credits, styles.label)}>{t('credits', { count: credits })}</span>
                )}
            </Component>
        </li>
    );
};
